import { supabase } from '@/lib/supabase';
import { getDeeplinkPrefix } from '@/shared/utils/deeplink-prefix';

export interface InviteProjectMembersInput {
  projectId: number;
  orgMemberIds: string[];
}

export const inviteProjectMembers = async ({
  projectId,
  orgMemberIds,
}: InviteProjectMembersInput) => {
  const { error } = await supabase.from('project_member_invites').insert(
    orgMemberIds.map((orgMemberId) => ({
      project_id: projectId,
      org_member_id: orgMemberId,
      deeplink_prefix: getDeeplinkPrefix(),
    })),
  );

  if (error) {
    throw error;
  }
  return;
};
